<template>
  <div>
    <v-flex xs12>
      <v-text-field v-model="clau" :label="$t('Clau')"></v-text-field>
    </v-flex>
    <div class="text-xs-right">
      <v-btn color="success" @click="guardar">{{ $t("Acceptar") }}</v-btn>
    </div>
    <v-alert :value="error" type="error">{{ errorMessage }}</v-alert>
    <v-alert :value="connectionError" type="warning">{{ connectionErrorMessage }}</v-alert>
  </div>
</template>

<script>
import api from "../api.js";

export default {
  data: () => ({
    clau: "",
    error: false,
    connectionError: false,
    errorMessage: "",
    connectionErrorMessage: "",
  }),
  created() {
    // Check if stored token is still valid
    const token = localStorage.getItem("systimes.token" + api.getEmp());
    if (token) {
      this.validateStoredToken(token);
    }
  },
  methods: {
    async validateStoredToken(token) {
      this.clearErrors();
      
      try {
        const result = await api.validateToken(token);
        
        if (result.isValid) {
          this.$store.commit("setAuth", true);
          this.$router.push("/");
        } else {
          this.$store.commit("setAuth", false);
          
          if (result.isConnectionError) {
            this.showConnectionError(result.error);
          }
          // If token is invalid, just stay on token screen without showing error
        }
      } catch (error) {
        console.error("Unexpected error validating stored token:", error);
        this.$store.commit("setAuth", false);
      }
    },
    
    async validateNewToken(token) {
      this.clearErrors();
      
      try {
        const result = await api.validateToken(token);
        
        if (result.isValid) {
          this.$store.commit("setAuth", true);
          this.$router.push("/");
        } else {
          this.$store.commit("setAuth", false);
          
          if (result.isConnectionError) {
            this.showConnectionError(result.error);
          } else {
            this.showTokenError();
          }
        }
      } catch (error) {
        console.error("Unexpected error validating new token:", error);
        this.$store.commit("setAuth", false);
        this.showTokenError();
      }
    },
    
    showConnectionError(error) {
      this.connectionError = true;
      this.error = false;
      
      if (localStorage.getItem("systimes.idioma" + api.getEmp()) == "Català") {
        if (!error.response) {
          this.connectionErrorMessage = "Error de connexió. Comproveu la connexió a internet.";
        } else {
          this.connectionErrorMessage = "Error del servidor. Intenteu-ho més tard.";
        }
      } else {
        if (!error.response) {
          this.connectionErrorMessage = "Error de conexión. Compruebe la conexión a internet.";
        } else {
          this.connectionErrorMessage = "Error del servidor. Inténtelo más tarde.";
        }
      }
    },
    
    showTokenError() {
      this.error = true;
      this.connectionError = false;
      
      if (localStorage.getItem("systimes.idioma" + api.getEmp()) == "Català") {
        this.errorMessage = "Clau incorrecta";
      } else {
        this.errorMessage = "Clave incorrecta";
      }
    },
    
    clearErrors() {
      this.error = false;
      this.connectionError = false;
      this.errorMessage = "";
      this.connectionErrorMessage = "";
    },
    
    guardar() {
      if (this.clau != "") {
        localStorage.setItem("systimes.token" + api.getEmp(), this.clau);
        this.validateNewToken(this.clau);
      } else {
        this.showTokenError();
      }
    },
  },
};
</script>
